var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.876709,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#EF7F18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67201 7.53558C5.21158 8.1706 7.43987 11.3168 9.03796 10.6219C9.32176 10.9921 10.2359 12.1846 10.5197 12.5548C9.84543 12.848 9.27467 13.0328 8.49297 12.6963C6.32252 11.7618 3.93332 8.64644 4.00142 6.78813C4.02503 6.14271 4.52992 5.88983 5.19034 5.60266C5.47413 5.97287 6.38821 7.16538 6.67201 7.53558Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2844 7.48304C7.12661 7.55165 6.92355 7.5107 6.83243 7.39184L5.43558 5.56964C5.34445 5.45077 5.39883 5.29784 5.55665 5.22922L6.2908 4.90998C6.44861 4.84135 6.65171 4.88234 6.74283 5.0012L8.13968 6.82338C8.23079 6.94223 8.17639 7.09516 8.0186 7.16378L7.2844 7.48304Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1008 12.4609C10.943 12.5295 10.7399 12.4886 10.6488 12.3697L9.25195 10.5475C9.16083 10.4287 9.21521 10.2757 9.37302 10.2071L10.1072 9.88788C10.265 9.81926 10.4681 9.86025 10.5592 9.9791L11.9561 11.8013C12.0472 11.9201 11.9928 12.0731 11.835 12.1417L11.1008 12.4609Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.334c2e89630422d94cbdd8d1502c5b30.svg";
export { ForwardRef as ReactComponent };